import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class OtherOperationListItem extends SearchModelBase {
    id: number = 0;
    closed: string = '';
    shipmentType: string = '';
    invStat: string = '';
    billStat: string = '';
    crDbStat: string = '';
    refNo: string = '';
    branch: string = '';
    category: string = '';
    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;
    pStatus: string = '';
    useIsfNo: boolean = false;
    mblNo: string = '';
    hblNo: string = '';
    vessel: string = '';
    container: string = '';
    customerName: string = '';
    shipper: string = '';
    consignee: string = '';
    customerRefNo: string = '';
    loadingPort: string = '';
    dischargePort: string = '';
    finalDestination: string = '';
    acctCloseBy: string = '';
    acctCloseDate: string | null = null;
    pCloseDate: string | null = null;
    autoOpCloseBy: string = '';
    opCloseBy: string = '';
    opCloseDate: string | null = null;
    u1ID: string = '';
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    u2ID: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    recognized: string = '';
    status: string = '';
    agent: number = 0;
    agentName: string = '';
    salesPerson: string = '';
    location: string = '';
    commodity: string = '';
    pkgs: number = 0;
    fromPkgs: number|null = null;
    toPkgs: number|null = null;
    unit: string = '';
    operator: string = '';
    paidDate: string = '';
    kgs: number = 0;
    fromKgs: number|null = null;
    toKgs: number|null = null;
    lbs: number = 0;
    fromLbs: number|null = null;
    toLbs: number|null = null;
    confirmDate: string | null = null;
    fromConfirmDate: string | null = null;
    toConfirmDate: string | null = null;

    trType: string = '';
    trStatus: string = '';
    trStatusDesc: string = '';
    trDate: string | null = null;
    fromTrDate: string | null = null;
    toTrDate: string | null = null;

    //Track Event
    lastEvent: string = '';
    lastEventDate: string | null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true }),
        XCol.Create({ col: 1, text: 'R', width: 30, dataIndex: 'recognized', noNullOrEmptySearch: true, hiddenInColumnSetup: true }),
        XCol.Create({ col: 26, text: 'D/ID', width: 35, dataIndex: 'shipmentType', noNullOrEmptySearch: true }),
        
        XCol.Create({ col: 2, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus : true}),
        XCol.Create({ col: 4, text: 'RQ', width: 210, dataIndex: 'trStatus' }),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Agent', width: 120, dataIndex: 'agentName', visible: false}),
        XCol.Create({ col: 5, text: 'Category', width: 80, dataIndex: 'category'}),
        XCol.Create({ col: 6, text: 'Date', width: 75, dataIndex: 'postDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 7, text: 'P', width: 40, dataIndex: 'pStatus', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 8, text: 'Paid', width: 80, dataIndex: 'paidDate',  type: XCol.XCellType.Date, align: XCol.XAlignType.Center}), //추가
        XCol.Create({ col: 9, text: 'ISF', width: 50, dataIndex: 'useIsfNo', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'MBL / MAWB', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 11, text: 'HBL / HAWB', width: 100, dataIndex: 'hblNo'}),  
        XCol.Create({ col: 12, text: 'Vessel & Voy/Flt', width: 120, dataIndex: 'vessel'}),
        XCol.Create({ col: 13, text: 'In-bond', width: 80, dataIndex: 'itNo' }),
        XCol.Create({ col: 14, text: 'Prep. By', width: 80, dataIndex: 'operator'}),  //추가
        XCol.Create({ col: 15, text: 'Container', width: 150, dataIndex: 'container'}),
        XCol.Create({ col: 16, text: 'PKG(s)', width: 60, dataIndex: 'pkgs', type: XCol.XCellType.Double, noNullOrEmptySearch: true, formatString: '#,##0'}),
        XCol.Create({ col: 17, text: 'KGS', width: 60, dataIndex: 'kgs', type: XCol.XCellType.Double, noNullOrEmptySearch: true, formatString: '#,##0.00'}),
        XCol.Create({ col: 18, text: 'LBS', width: 60, dataIndex: 'lbs', type: XCol.XCellType.Double, noNullOrEmptySearch: true, formatString: '#,##0.00'}),
        XCol.Create({ col: 19, text: 'Customer', width: 120, dataIndex: 'customerName'}),
        XCol.Create({ col: 20, text: 'Shipper', width: 120, dataIndex: 'shipper'}),
        XCol.Create({ col: 21, text: 'Consignee', width: 120, dataIndex: 'consignee'}),
        XCol.Create({ col: 22, text: 'Customer Ref.', width: 100, dataIndex: 'customerRefNo'}),
        XCol.Create({ col: 23, text: 'Location', width: 80, dataIndex: 'location'}),
        XCol.Create({ col: 24, text: 'Loading Port', width: 120, dataIndex: 'loadingPort'}),
        XCol.Create({ col: 25, text: 'Discharge Port', width: 120, dataIndex: 'dischargePort'}),
        XCol.Create({ col: 26, text: 'Final Destination', width: 120, dataIndex: 'finalDestination'}),
        XCol.Create({ col: 27, text: 'Sales', width: 80, dataIndex: 'salesPerson', visible: false}),
        
        XCol.Create({ col: 28, text: 'INV', width: 35, dataIndex: 'invStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 29, text: 'BIL', width: 35, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 30, text: 'CrDb', width: 35, dataIndex: 'crDbStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        
        XCol.Create({ col: 31, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 32, text: 'Create by', width: 80, dataIndex: 'u1ID' ,visible: false}),
        XCol.Create({ col: 33, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 34, text: 'Update by', width: 80, dataIndex: 'u2ID', visible: false}),
    
        // XCol.Create({ col: 23, text: 'Location', width: 100, dataIndex: 'location', visible: false}),
        // XCol.Create({ col: 24, text: 'Commodity', width: 120, dataIndex: 'commodity'}),
        // XCol.Create({ col: 26, text: 'Unit', width: 80, dataIndex: 'unit'}),

        ];


    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        postDate: {from: 'fromPostDate', to: 'toPostDate'},
        pkgs: {from: 'fromPkgs', to: 'toPkgs'},
        paidDate: {from: 'fromPaidDate', to: 'toPaidDate'},
        kgs: {from: 'fromKgs', to: 'toKgs'},
        lbs: {from: 'fromLbs', to: 'toLbs'},
        confirmDate: {from: 'fromConfirmDate', to: 'toConfirmDate'},
    }
	
    public static OrderBy = { orderBy: OtherOperationListItem.prototype.postDate, orderByAscending: false };
}
